import "./index.less";
import { graphicStore } from "@/commons/store/graphic-store";
import SideBar from "./sidebar/side";
import StmodeInput from "@/panel/graphic/stmode-input";
import SystemSwitch from "@/panel/graphic/system-switch";
import MenuBar from "./menu";
import { DymodeInput } from "pytha-ui";
import SystemManagementArea from "./header/header";
import OperationBar from "./operation-bar";
import TabRoutes from "@/routes/tab-routes";
import { CommonTabbarContext, SystemContext } from "@/App";
import CommonTabbar from "@/commons/components/common-tabbar";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect } from "react";
import { getProjectDetail } from "@/api/project/project";
import { findModels, getModelDetail } from "@/api/project/model";
import { ModelType } from "@/commons/enums/model-file-type";
import localStore from "@/commons/store/local-store";
import { SystemStatus } from "@/commons/context/system-store";
import { Model } from "@/commons/interface/project/model";
export interface IProps {
    feedbackVisible: boolean,
    changeFeedbackVisible: (value: boolean) => void
}

export default function ProjectLayout(props: IProps) {

    const { feedbackVisible, changeFeedbackVisible } = props;

    const sideBarWidth = 300;

    const { projectUuid, modelUuid, branchUuid } = useParams();
    const systemContext = useContext<SystemStatus>(SystemContext);

    const navigate = useNavigate();

    useEffect(() => {
        if (!projectUuid) {
            localStore.projectUuid = null;
            systemContext.setCurrentProjectUuid(null);
            return;
        }
        getProjectDetail(projectUuid).then(res => {
            if (res == null || !res.data || Object.keys(res.data).length === 0) {
                navigate("/desktop");
                return;
            };
            if (modelUuid) {
                getModelDetail(modelUuid).then(res => {
                    if (res == null || !res.data || Object.keys(res.data).length === 0) {
                        navigate(`/project/${projectUuid}`);
                        return;
                    };
                    let model: Model = res.data
                    if (!branchUuid) {
                        systemContext.setShowModelUuidListValue([model.uuid]);
                    } else {
                        systemContext.setShowModelUuidListValue([]);
                    }
                    systemContext.setCurrentModelUuid(model.uuid);
                    systemContext.setCurrentBuildingUuid(model.buildingUuid);
                    localStore.modelUuid = model.uuid;
                })
            } else {
                findModels(projectUuid).then(res => {
                    // 查询场地模型，默认选中场地模型
                    let modelList = res.data || [];
                    let model = modelList.find(item => item.type == ModelType.SITE);
                    if (!model && modelList.length > 0) {
                        model = modelList[0];
                    }
                    if (!!model) {
                        systemContext.setShowModelUuidListValue([model.uuid]);
                        systemContext.setCurrentModelUuid(model.uuid);
                        systemContext.setCurrentBuildingUuid(model.buildingUuid);
                        localStore.modelUuid = model.uuid;
                        navigate(`/project/${projectUuid}/model/${model.uuid}`)
                    }
                })
            }
        }).catch(err => {
            navigate("/desktop");
        })
    }, [projectUuid, modelUuid, branchUuid])

    return (
        <div className="bim-project-container">
            <SystemManagementArea feedbackVisible={feedbackVisible} changeFeedbackVisible={changeFeedbackVisible} />
            <div className="menu">
                <MenuBar sideBarWidth={sideBarWidth}></MenuBar>
            </div>
            <div className="main">
                <div className="side-bar" style={{ width: sideBarWidth }}>
                    <SideBar
                        width={sideBarWidth}
                    />
                </div>
                <div className="draw">
                    <OperationBar />
                    <CommonTabbar className="draw-tab" context={CommonTabbarContext} />
                    <TabRoutes />
                    <DymodeInput
                        context={graphicStore.context}
                        extraContext={graphicStore.extraContext}
                        leftOffset={20}
                        topOffset={20}
                    />
                </div>
            </div>
            <div className="bottom">
                <StmodeInput width={sideBarWidth} />
                <SystemSwitch />
            </div>
        </div>
    )
}
